import { useLocation } from 'react-router-dom';

interface Params {
  edtTemplateId?: string;
  sequenceTemplateId?: string;
  programmationTemplateId?: string;
  edtTemplateDocumentId?: string;
  sequenceTemplateDocumentId?: string;
  programmationTemplateDocumentId?: string;
  parrainageToken?: string;
  parrainName?: string;
  shareToken?: string;
  shareEntityId?: string;
  shareEntityType?: string;
}

export function useInscriptionParams(): Params {
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);

  const edtTemplateId = urlSearchParams.get('edt-template-id') || undefined;
  const programmationTemplateId =
    urlSearchParams.get('programmation-template-id') || undefined;
  const sequenceTemplateId =
    urlSearchParams.get('sequence-template-id') || undefined;
  const shareEntityType = urlSearchParams.get('share-entity-type') || undefined;
  const shareEntityId = urlSearchParams.get('share-entity-id') || undefined;
  const shareToken = urlSearchParams.get('share-token') || undefined;
  const parrainageToken = urlSearchParams.get('token') || undefined;
  const parrainName = urlSearchParams.get('parrain-name') || undefined;

  const params = {
    edtTemplateId,
    sequenceTemplateId,
    programmationTemplateId,
    shareToken,
    shareEntityId,
    shareEntityType,
    parrainageToken,
    parrainName,
  };

  return params;
}
